export default "__VITE_ASSET__82efe0a3__"